import { defineStore } from 'pinia';

export type ModalType = 'PostCreation' | 'OrdersDetailModal' | 'bottomPopup' | 'GuideModal'; // 모달 이름

type StoreStateType = {
	modal: ModalType[];
};

export const useModalStore = defineStore('modal', {
	state: (): StoreStateType => {
		return {
			modal: [],
		};
	},
	actions: {
		checkModalOpen(modalName: ModalType) {
			return this.modal.includes(modalName);
		},
		openModal(modalName: ModalType) {
			if (this.checkModalOpen(modalName)) {
				console.error('no modal', modalName);
				return;
			}
			document.body.classList.add('hidden');
			this.modal.push(modalName);
		},
		closeModal(modalName: ModalType) {
			if (this.modal.length < 1) {
				console.error('no modalList');
				return;
			}
			if (this.modal.at(-1) === modalName) {
				document.body.classList.remove('hidden');
				this.modal.pop();
			}
		},
		closeAll() {
			this.$reset();
		},
	},
});
